import { useContext, createContext } from 'react'

type ToastType = 'success' | 'error'

interface ToastContextValue {
  showToast: (message: string, type?: ToastType) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)

// Global reference for use outside React (e.g., in QueryClient config)
let globalShowToast: ((message: string, type?: ToastType) => void) | null = null

export function getGlobalToast() {
  return globalShowToast
}

export function setGlobalToast(fn: ((message: string, type?: ToastType) => void) | null) {
  globalShowToast = fn
}

export function useToast() {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}
